const emailSubstrings = ["gmail", "yahoo", "outlook", "rediff"];

export const checkEmailSubstring = (email: string) => {
  return emailSubstrings.some((subString) => email.includes(subString));
};
